export function formatDate(value) {
    if (!value) return "";

    const raw = String(value).trim();
    const naiveMatch = raw.match(
        /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/,
    );
    const hasExplicitTimezone = /([zZ]|[+-]\d{2}:\d{2})$/.test(raw);

    // Les dates SQL sans timezone sont déjà en heure locale métier (Paris):
    // on les affiche telles quelles pour éviter tout décalage navigateur.
    if (naiveMatch && !hasExplicitTimezone) {
        const [, year, month, day, hour, minute, second = "00"] = naiveMatch;
        return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
    }

    try {
        const d = new Date(raw);
        if (isNaN(d.getTime())) return String(value);
        return d.toLocaleString("fr-FR", {
            timeZone: "Europe/Paris",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
    } catch {
        return String(value);
    }
}
